<template>
  <button @click.stop="$emit('click')">{{text}}</button>
</template>

<script>
export default {
  props: ['text']

}
</script>

<style lang="scss" scoped>
button {
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50px;
  background: #DADADA;
  border: none;
  color: #FFFFFF;
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  &.active {
    background: var(--color-pri);
  }
}
</style>
